module.exports = __webpack_public_path__ + "static/img/logo_login.b2fd925d.png";